import React from 'react'
import { SkeletonBox } from './styles'

export const Skeleton = (props) => {
  const { $width, $height, $marginBottom, ...rest } = props
  return <SkeletonBox $width={$width} $height={$height} $marginBottom={$marginBottom} {...rest} />
}
